// extracted by mini-css-extract-plugin
module.exports = {"category-label":"PostHeader_category-label__3dV0S","category-link":"PostHeader_category-link__0v_kH","category-separator":"PostHeader_category-separator__5h6M0"};